import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../../../../../components/ui/Button';
import { Spinner } from '../../../../../components/ui/Spinner';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogBody,
  DialogFooter,
  DialogTitle,
} from '../../../../../components/ui/Dialog';

interface BrandingActionsProps {
  isSaving: boolean;
  onReset: () => void;
  onSave: () => void;
}

const BrandingActions: React.FC<BrandingActionsProps> = ({ isSaving, onReset, onSave }) => {
  const { t } = useTranslation();
  const [confirmOpen, setConfirmOpen] = useState(false);

  const handleResetConfirmed = () => {
    setConfirmOpen(false);
    onReset();
  };

  return (
    <>
      <div className="flex justify-end gap-3 mt-6 pt-4 border-t border-border">
        <Button
          variant="outline"
          size="sm"
          onClick={() => setConfirmOpen(true)}
          disabled={isSaving}
        >
          {t('Reset')}
        </Button>

        <Button
          variant="default"
          size="sm"
          onClick={onSave}
          disabled={isSaving}
          data-testid="save-btn"
        >
          {isSaving && <Spinner size="sm" className="me-2" />}
          {isSaving ? t('Saving...') : t('Save')}
        </Button>
      </div>

      {/* Reset confirmation dialog */}
      <Dialog open={confirmOpen} onOpenChange={setConfirmOpen}>
        <DialogContent size="sm">
          <DialogHeader>
            <DialogTitle>{t('Reset Branding')}</DialogTitle>
          </DialogHeader>
          <DialogBody>
            <p className="text-sm text-muted-foreground">
              {t('Are you sure you want to reset all branding settings to default?')}
            </p>
          </DialogBody>
          <DialogFooter>
            <Button variant="outline" size="sm" onClick={() => setConfirmOpen(false)}>
              {t('Cancel')}
            </Button>
            <Button variant="destructive" size="sm" onClick={handleResetConfirmed}>
              {t('Reset')}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default BrandingActions;
